window.Fancybox = require("@fancyapps/ui").Fancybox;
window.Carousel = require("@fancyapps/ui").Carousel;
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";

const container = document.getElementById("myCarousel");
if (container)
{
    const options = {
        Dots: false, 
        Navigation: false,
        Thumbs: { type: "classic" },
    };
    new Carousel(container, options, { Thumbs });
}

window.FancyboxFr = '@fancyapps/ui/dist/fancybox/l10n/fr.esm.js';

Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    l10n: FancyboxFr,
});